<template>
  <path
    fill="currentColor"
    d="M6 19.5h3V18h1.5q.637 0 1.07-.432.431-.432.43-1.068V12q0-.638-.432-1.068A1.46 1.46 0 0 0 10.5 10.5H6V9h6V6H9V4.5H6V6H4.5q-.637 0-1.068.432A1.46 1.46 0 0 0 3 7.5V12q0 .637.432 1.07.432.431 1.068.43H9V15H3v3h3zM14 5v4.6l.006-2L14 9.606 16.333 12 14 14.4l.006.006-.006 2V19h7v-4.594l-.006 2L21 14.4 18.667 12 21 9.606 20.994 7.6l.006 2V5z"
  />
</template>
